export const formatDecimal = (val: number | null, toDecimal = 2) =>
  val !== null && String(val).length && !isNaN(Number(val)) ? Number(val).toFixed(toDecimal) : val;
